import React, { useState } from "react";

import PromptWriter from "../prompts/PromptWriter";

const JsonEditorView = ({ item, onChange }) => {
  const jsonString = JSON.stringify(item, null, 2);

  return (
    <div className="h-full w-full flex flex-col overflow-hidden">
      <PromptWriter value={jsonString} onChange={onChange} language="json" />
    </div>
  );
};

export default JsonEditorView;
